import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/styles';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles(theme => ({
  placeholder: {
    color: theme.palette.ava.blue2,
    fontSize: 18,
    left: 2,
    marginLeft: 16,
    overflow: 'hidden',
    position: 'absolute',
    textAlign: 'left',
    width: 'calc(100% - 15px)',
  },
}));

const JoinConversationPlaceholder = ({ innerProps, selectProps }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Typography color="textSecondary" className={classes.placeholder} {...innerProps} noWrap>
      {selectProps.autoFocus ? t('joinConversation.enterAvaUsername') : t('sidebar.buttons.joinAConversation')}
    </Typography>
  );
};

export default JoinConversationPlaceholder;
